import { t } from 'i18next';

import { CryptoPayoutStatus } from 'types/cryptoPayout';

import { makeLabels } from 'utils/i18n';

const STATUS_LABELS: Record<CryptoPayoutStatus, [string, string]> = {
  [CryptoPayoutStatus.Initiated]: ['initiated', 'Initiated'],
  [CryptoPayoutStatus.Pending]: ['pending', 'Pending'],
  [CryptoPayoutStatus.Submitted]: ['submitted', 'Submitted'],
  [CryptoPayoutStatus.Confirmed]: ['confirmed', 'Confirmed'],
  [CryptoPayoutStatus.Completed]: ['completed', 'Completed'],
  [CryptoPayoutStatus.Canceled]: ['canceled', 'Cancelled'],
  [CryptoPayoutStatus.Failed]: ['failed', 'Failed'],
};

const NAMESPACE = 'components.cryptoPayoutStatusBadge';
export const LABELS = makeLabels(
  {
    STATUSES: STATUS_LABELS,
  },
  NAMESPACE,
);

export const statusToLabelMap: Record<CryptoPayoutStatus, { type: CryptoPayoutStatus; label: string }> = {
  [CryptoPayoutStatus.Initiated]: {
    type: CryptoPayoutStatus.Initiated,
    label: t(LABELS.STATUSES[CryptoPayoutStatus.Initiated]),
  },
  [CryptoPayoutStatus.Pending]: {
    type: CryptoPayoutStatus.Pending,
    label: t(LABELS.STATUSES[CryptoPayoutStatus.Pending]),
  },
  [CryptoPayoutStatus.Submitted]: {
    type: CryptoPayoutStatus.Submitted,
    label: t(LABELS.STATUSES[CryptoPayoutStatus.Submitted]),
  },
  [CryptoPayoutStatus.Confirmed]: {
    type: CryptoPayoutStatus.Confirmed,
    label: t(LABELS.STATUSES[CryptoPayoutStatus.Confirmed]),
  },
  [CryptoPayoutStatus.Completed]: {
    type: CryptoPayoutStatus.Completed,
    label: t(LABELS.STATUSES[CryptoPayoutStatus.Completed]),
  },
  [CryptoPayoutStatus.Canceled]: {
    type: CryptoPayoutStatus.Canceled,
    label: t(LABELS.STATUSES[CryptoPayoutStatus.Canceled]),
  },
  [CryptoPayoutStatus.Failed]: {
    type: CryptoPayoutStatus.Failed,
    label: t(LABELS.STATUSES[CryptoPayoutStatus.Failed]),
  },
};
